import { filterCapitalize } from "@/filters/capitalize";
import { SelectItem } from "@/models/api/SelectItem";
import i18n from "@/plugins/i18n";

export enum NOTIFICATION_FREQUENCY {
  OnChange = 1,
  Daily = 2,
}

export const notificationFrequencySelect = [
  { value: NOTIFICATION_FREQUENCY.OnChange, text: filterCapitalize(i18n.t("onChange")) } as SelectItem,
  { value: NOTIFICATION_FREQUENCY.Daily, text: filterCapitalize(i18n.t("daily2")) } as SelectItem,
];
